import { useDispatch, useSelector } from "react-redux";
import { IoClose } from "react-icons/io5"
import { setOpenChoicePeriod, setOpenMainMenu, setOpenRevenue } from "../../Reducer/ModalSlice";
import { useEffect, useState } from "react";
import { setPeriod } from "../../Reducer/PeriodSlice";
import { TotalSumFunction, setPercentCity, setRevenueArray } from "../../Reducer/RevenueSlice";
import { StaffHours, StaffOneDaySumHours, StaffSelectedCityArrayAdd, setHoursStaff } from "../../Reducer/StaffSlice";
import { CityAddRevenue } from "../../Reducer/CitySlice";

function ModalChoicePeriod() {
    const SelectedMonth = useSelector(state => state.MonthSlice.SelectedMonth)

    const SelectedCity = useSelector(state => state.CitySlice.SelectedCity)

    const AllMonthRavenue = useSelector(state => state.RevenueSlice.AllMonthRavenue)

    const StaffArray = useSelector(state => state.StaffSlice.StaffArray)
    const StaffAllMonth = useSelector(state => state.StaffSlice.StaffAllMonth)
    

    const dispatch = useDispatch()
    const [MaxDay, setMaxday] = useState()
    const [MonthCheck, setMonthCheck] = useState()
    const [MinDayValue, setMinDayValue] = useState(0)
    const [MaxDayValue, setMaxDayValue] = useState(0)
    const [CancelTouch, setCancelTouch] = useState(false)

    useEffect(() => {
        switch(SelectedMonth.MonthValue){
            case(1):{
                setMonthCheck('01')
                setMaxday('31')
                break;
            }
            case(2):{
                setMonthCheck('02')
                setMaxday('28')
                break;
            }
            case(3):{
                setMonthCheck('03')
                setMaxday('31')
                break;
            }
            case(4):{
                setMonthCheck('04')
                setMaxday('30')
                break;
            }
            case(5):{
                setMonthCheck('05')
                setMaxday('31')
                break;
            }
            case(6):{
                setMonthCheck('06')
                setMaxday('30')
                break;
            }
            case(7):{
                setMonthCheck('07')
                setMaxday('31')
                break;
            }
            case(8):{
                setMonthCheck('08')
                setMaxday('31')
                break;
            }
            case(9):{
                setMonthCheck('09')
                setMaxday('30')
                break;
            }
            case(10):{
                setMonthCheck('10')
                setMaxday('31')
                break;
            }
            case(11):{
                setMonthCheck('11')
                setMaxday('30')
                break;
            }
            case(12):{
                setMonthCheck('12')
                setMaxday('31')
                break;
            }
            default:{
                break;
            }
        }
        // eslint-disable-next-line
    }, [])
    
    const handleClickChoicePeriodButton = async (event) => {
        if(event.type === 'touchend')
            event.preventDefault()

        if(MaxDayValue > 1 && MinDayValue <= MaxDayValue)
        {
            await dispatch(setPeriod({MinDay: MinDayValue, MaxDay: MaxDayValue, PeriodOn: true}))
            var RevenuePushed = []
            var PercentPushed = []
            AllMonthRavenue.map((item) => {
            if(SelectedMonth.YearValue === item.YearValue && SelectedMonth.MonthValue === item.MonthValue && SelectedCity.id === item.idCity)
            {
                dispatch(CityAddRevenue({idCity: SelectedCity.id, idRevenue: item.id, Revenue: item.Revenue, Percent: item.Percent}))
                                

                var filteredRevenue = item.Revenue
                var filteredPercentCity = item.Percent
                filteredPercentCity = filteredPercentCity.split('_')
                filteredRevenue = filteredRevenue.split('_')
                                
                filteredRevenue.map((a, index) => {
                    RevenuePushed.push({id: (parseInt(index)), Value: a})
                    return(a)
                })

                filteredPercentCity.map((a) => {
                    PercentPushed.push(a)
                    return(a)
                })
                                
                dispatch(setRevenueArray(RevenuePushed))
                document.documentElement.style.setProperty('--widthFirstStaffPostDiv', '1230px');
                
                var SecondRevenuePeriodCheck = 0
                RevenuePushed.map((el) => {
                    if(el.id < MaxDayValue && el.id > parseInt(MinDayValue - 2) && el.id > 14)
                    {
                        SecondRevenuePeriodCheck = parseInt(SecondRevenuePeriodCheck) + 1
                    }
                    return(el)
                })
                var SecondWidthCheck = (SecondRevenuePeriodCheck * 82) - 1
                SecondWidthCheck = SecondWidthCheck + 'px'
                document.documentElement.style.setProperty('--widthSecondStaffPostDiv', SecondWidthCheck);

                var RevenuePeriodCheck = 0
                RevenuePushed.map((el) => {
                    if(el.id < MaxDayValue && el.id > parseInt(MinDayValue - 2) && el.id < 15)
                    {
                        RevenuePeriodCheck = parseInt(RevenuePeriodCheck) + 1
                    }
                    return(el)
                })
                var WidthCheck = (RevenuePeriodCheck * 82) + 2
                WidthCheck = WidthCheck + 'px'
                document.documentElement.style.setProperty('--widthFirstStaffPostDiv', WidthCheck);

                var StaffGlobalDivWidthcCheck = parseInt(RevenuePushed.length)
                if(MaxDayValue > 15 && parseInt(MinDayValue - 2) < 14)
                {
                    StaffGlobalDivWidthcCheck = (SecondRevenuePeriodCheck * 82) + (RevenuePeriodCheck * 82) + 2032 + 10
                }
                else
                {
                    StaffGlobalDivWidthcCheck = (SecondRevenuePeriodCheck * 82) + (RevenuePeriodCheck * 82) + 955 + 10
                }


                StaffGlobalDivWidthcCheck = StaffGlobalDivWidthcCheck + 'px'
                document.documentElement.style.setProperty('--widthStaffGlobalDiv', StaffGlobalDivWidthcCheck);

                dispatch(setPercentCity(PercentPushed))
                dispatch(StaffSelectedCityArrayAdd(StaffArray.filter((a) => a.idCity === SelectedCity.id && (parseInt(new Date(a.created_at).getMonth() + 1) <= parseInt(SelectedMonth.MonthValue) || parseInt(new Date(a.created_at).getFullYear()) < parseInt(SelectedMonth.YearValue)))))
                StaffArray.map((a) => {
                    StaffAllMonth.map((itemStaff) => {
                        if(itemStaff.YearValue === SelectedMonth.YearValue && itemStaff.MonthValue === SelectedMonth.MonthValue && a.id === itemStaff.idStaff)
                        dispatch(setHoursStaff({idHourses: itemStaff.id, idStaff: itemStaff.idStaff, Hours: itemStaff.Hours, Additional: itemStaff.Additional, Rate: itemStaff.Rate, Shift: itemStaff.Shift, Prize: itemStaff.Prize, SecondRate: itemStaff.SecondRate, SecondShift: itemStaff.SecondShift, SecondPrize: itemStaff.SecondPrize, Hidden: itemStaff.Hidden}))
                    return(itemStaff)
                    })
                return(a)
                })
                                
            }
                return(item)
            })
            await dispatch(StaffHours({MinDay: MinDayValue, MaxDay: MaxDayValue}))
            await RevenuePushed.map((a) => {
                if(a.id > -1 && a.id < (RevenuePushed.length))
                dispatch(StaffOneDaySumHours(a.id))
                return(a)
            })
                        
            dispatch(TotalSumFunction({MinDay: MinDayValue, MaxDay: MaxDayValue}))
            
            await dispatch(setOpenChoicePeriod(false))
            dispatch(setOpenRevenue(true))
        }
        else
        {
            alert('Не выбран период')
        }
    }

    return(
        <div
        className="ModalGlobalDiv"
        >
            <div
            className="ModalMainDiv"
            >
                <div
                className="ModalInformationDiv"
                >
                    <div>
                        
                    </div>
                    <div
                    className="ModalInformationTextDiv"
                    >
                        Выбор периода
                    </div>
                    <button
                    className="CloseModalIconDiv"
                    onClick={(() =>{
                        dispatch(setOpenChoicePeriod(false))
                        dispatch(setOpenMainMenu(true))
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={((event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                        {
                            dispatch(setOpenChoicePeriod(false))
                            dispatch(setOpenMainMenu(true))
                        }
                    })}
                    >
                        <IoClose
                        className="CloseModalIcon"
                        />
                    </button>
                </div>
                <div
                className="ChoicePeriodCityText"
                >
                        {SelectedCity.City + ' ' + SelectedCity.Adress + ' ' + SelectedMonth.Name}
                </div>
                <div
                className="ChoicePeriodInputsDiv"
                >
                    С
                    <input
                    className="ChoicePeriodInput"
                    id='ChoicePeriodInput First'
                    type="date"
                    value={SelectedMonth.YearValue + '-' + MonthCheck + '-' + String(MinDayValue).padStart(2, '0')}
                    min={SelectedMonth.YearValue + '-' + MonthCheck + '-01'} 
                    max={SelectedMonth.YearValue + '-' + MonthCheck + '-' + MaxDay}
                    onChange={((e) => {
                        if((new Date(e.target.value).getDate()) <= MaxDayValue)
                            return(setMinDayValue(new Date(e.target.value).getDate()))
                        setMinDayValue(MaxDayValue)
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(() => {
                        if(!CancelTouch)
                            document.getElementById('ChoicePeriodInput First').focus()
                    })}
                    />   

                    По
                    <input
                    className="ChoicePeriodInput"
                    id='ChoicePeriodInput Second'
                    type="date"
                    value={SelectedMonth.YearValue + '-' + MonthCheck + '-' + String(MaxDayValue).padStart(2, '0')}
                    min={SelectedMonth.YearValue + '-' + MonthCheck + '-01'} 
                    max={SelectedMonth.YearValue + '-' + MonthCheck + '-' + MaxDay}
                    onChange={((e) => {
                            if((new Date(e.target.value).getDate()) >= MinDayValue)
                                return(setMaxDayValue(new Date(e.target.value).getDate()))
                            setMaxDayValue(MinDayValue)
                    })}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(() => {
                        if(!CancelTouch)
                            document.getElementById('ChoicePeriodInput Second').focus()
                    })}
                    />   
                </div>
                <div
                className="ChoicePeriodCityText"
                >
                    <button
                    className="ButtonMainMenu"
                    onClick={handleClickChoicePeriodButton}
                    onTouchStart={() => {
                        setCancelTouch(false)
                    }}
                    onTouchMove={() => {
                        setCancelTouch(true)
                    }}
                    onTouchCancel={() => {
                        setCancelTouch(true)
                    }}
                    onTouchEnd={(event) => {
                        event.preventDefault()
                        if(!CancelTouch)
                            handleClickChoicePeriodButton(event)
                    }}
                    >
                        Показать
                    </button>
                </div>

            </div>
        </div>
    )
}

export default ModalChoicePeriod;
